import React, { useState, useEffect } from 'react';
import Flag from "../../Common/Components/Flag.jsx";
import SportsmenImageNba from "../../Common/Components/SportsmenImageNba.jsx";
import {FormattedMessage, FormattedNumber} from "react-intl";

const TeamDetailsTableSimple = ({team, columns, mark, startlist, stages, upcomingStages, activeStage}) => {

    if (!team) {
        return null
    }

    if (stages === false || stages === null || typeof stages === "undefined") {
        return <table className="zw-tbl team-details-tbl-simple">
            <thead><HeaderRow columns={columns}/></thead>
            <Rows markedSportsmen={mark ? mark.sportsmen : null} columns={columns} details={team.mainSquad}/>
            <FormattedMessage id="details.substitutes">{message =>
                <Rows markedSportsmen={mark ? mark.sportsmen : null} columns={columns} details={team.substitutes}
                      title={message}/>
            }</FormattedMessage>
            <Predictions compareWith={mark ? mark.predictions : null} predictions={team.predictions} teamTimeTrial={team.teamTimeTrial} columns={columns}/>
            <PointsTotal points={team.pointsTotal} place={team.place} columns={columns}/>
        </table>;

    }
    else{
        
        const currentStage = stages.find(item => item.index === activeStage) || upcomingStages.find(item => item.index === activeStage);
        // const getStartlist = startlist.supermatch[currentStage.supermatch]
        const getStartlist = startlist && startlist.supermatch && startlist.supermatch[currentStage.supermatch]
            ? startlist.supermatch[currentStage.supermatch]
            : null;

        let sportsmenStartlist = null;
        if (getStartlist && getStartlist.sportsmenTeam) {
            sportsmenStartlist = getStartlist.sportsmenTeam;
        } else {
            sportsmenStartlist = null;
        }
        return <table className="zw-tbl team-details-tbl-simple">
            <thead><HeaderRow columns={columns}/></thead>
            <Rows 
                markedSportsmen={mark ? mark.sportsmen : null} 
                columns={columns} 
                details={team.mainSquad} 
                sportsmenStartlist={sportsmenStartlist}
                stages={stages}
                activeStage={activeStage} 
            />
            <FormattedMessage id="details.substitutes">{message =>
                <Rows 
                    markedSportsmen={mark ? mark.sportsmen : null} 
                    columns={columns} 
                    details={team.substitutes}
                    sportsmenStartlist={sportsmenStartlist} 
                    title={message}/>
            }</FormattedMessage>
            <Predictions compareWith={mark ? mark.predictions : null} predictions={team.predictions} teamTimeTrial={team.teamTimeTrial} columns={columns}/>
            <PointsTotal points={team.pointsTotal} place={team.place} columns={columns}/>
        </table>;
    }
};

const TitleRow = ({text})=> {
    if (!text) {
        return <tr className="title-row">
            <th colSpan="1000" dangerouslySetInnerHTML={{__html: '&nbsp;'}}/>
        </tr>
    }

    return <tr>
        <th colSpan="1000">{text}</th>
    </tr>
};

const Predictions = ({predictions, columns, teamTimeTrial, compareWith}) => {
    if (!predictions) {
        return null;
    }
    return <tbody className="tbl-predictions">
    <FormattedMessage id="details.predictions">
        {message =>
            <TitleRow text={message}/>}</FormattedMessage>
    {predictions.map((prediction, i) => {
        const otherPrediction = compareWith ? compareWith.find(e => e.id == prediction.id) : null;
        return <PredictionRow key={i}
                              mark={!!otherPrediction && otherPrediction.refId == prediction.refId}
                              columns={columns}
                              prediction={prediction}/>;
    })}
    {teamTimeTrial ? <tr>
        {columns.map((col, i)=><td key={i}>{
            col.type === 'name' ?
                <FormattedMessage
                    id="details.teamTimeTrial">{message => <span>{`${teamTimeTrial} (${message})`}</span>}</FormattedMessage>
                : null
        }</td>)}
    </tr> : null}
    </tbody>
};
const PointsTotal = ({points, place, columns}) => {
    return <tbody className="points-total-tbody">
    <TitleRow/>
    <tr>
        {columns.map((col, i)=><td key={i}>{
            col.type == 'points' && points || col.type == 'name' && <FormattedMessage id="details.pointsTotal"/>
        }</td>)}
    </tr>
    <tr>
        {columns.map((col, i)=><td key={i}>{
            col.type == 'points' && place || col.type == 'name' && <FormattedMessage id="details.rankingPosition"/>
        }</td>)}
    </tr>
    </tbody>
};

const PredictionRow = ({prediction, columns, mark}) => {
    return <tr className={'prediction-row' + (mark ? ' team-detail--marked' : '')}>
        {columns.map((col, i)=><td key={i}>{predictionCellContent(col, prediction)}</td>)}
    </tr>
};

const predictionCellContent = (column, prediction) => {
    switch (column.type) {
        case 'index':
            return <PredictionImg jersey={prediction.jersey} image={prediction.image} title={prediction.title}/>;
        case 'flag':
            return <Flag code={prediction.countryCode}/>;
        case 'image':
            return prediction.image ? <SportsmenImageNba name={prediction.name} imageSrc={prediction.imageSrc}/> : '';
        case 'points':
            return prediction.points;
        case 'name':
            //todo: refactor class names
            return prediction.type === 'prediction-sportsman' ?
                <span title={prediction.name} className="team-detail__name-wrap">
                <SportsmenStateIcon participates={prediction.participates}
                                    abandoned={prediction.abandoned}
                                    starting={true}
                                    substitute={false}
                /><span className="team-detail__name">{prediction.name}</span></span>
                : prediction.name;
        default:
            return null;
    }
};

const Rows = ({ details, columns, title, markedSportsmen, sportsmenStartlist }) => {

    return details && (
      <tbody>
        {title && <TitleRow text={title} />}
        {details.map((detail, i) => { // Log the value of each detail object
          return (
            <TeamDetail
              marked={markedSportsmen && markedSportsmen.includes(detail.sportsmenId)}
              detail={detail}
              columns={columns}
              i={i + 1}
              key={i}
              sportsmenStartlist={sportsmenStartlist}
            />
          );
        })}
      </tbody>
    ) || null;
  };

const HeaderRow = ({columns}) => {
    return <tr>{columns.map((col, i) => <th key={i}>{col.abbr ? <abbr title={col.header}>{col.abbr}</abbr> : col.header}</th>)}</tr>
};

const TeamDetail = ({ detail, columns, i, marked, sportsmenStartlist }) => {

    const [isRowMarked, setIsRowMarked] = useState(false); // State to track row marked status
  
    useEffect(() => {
      setIsRowMarked(marked); // Update the row marked status based on the `marked` prop
    }, [marked]);
  
    return (
      <tr className={isRowMarked ? 'team-detail--marked' : undefined}>
        {columns.map((column, j) => (
          <td key={j}>{teamDetailCellContent(column, detail, i, sportsmenStartlist )}</td>
        ))}
      </tr>
    );
  };
  

const teamDetailCellContent = (column, detail, index, sportsmenStartlist ) => {
    let nameId = `sportsman_${detail.sportsmenId}`;

    const startlistChecker = sportsmenStartlist && sportsmenStartlist.length
            ? sportsmenStartlist.find(item => item.sportsmenId == detail.sportsmenId)
            : null;

    
    let activeSportsmen = startlistChecker ? 'team-detail__name-wrap--active' : 'team-detail__name-wrap';
    
    switch (column.type) {
        case 'flag':
            return <Flag code={detail.countryCode}/>;
        case 'image':
            return <SportsmenImageNba imageSrc={detail.imageSrc} name={detail.name}/>;
        case 'teamImage':
            return <SportsmenImageNba imageSrc={detail.teamImageSrc} name={detail.team}/>;
        case 'pointsPerMillion':
            return <FormattedNumber
                value={detail.points / detail.value}
                maximumFractionDigits={2}
            />;
        case 'value':
            return <FormattedNumber
                value={detail.value}
                maximumFractionDigits={2}
            />;
        case 'popularity':
            return detail.popularity ?<FormattedNumber
                style="percent"
                value={detail.popularity/100}
            /> : null;
        case 'index':
            return index;
        case 'name':
            return (
                <span title={detail.name} className={`${activeSportsmen}`}>
                    <SportsmenStateIcon
                        participates={detail.participates}
                        abandoned={detail.abandoned}
                        starting={detail.starting}
                        substitute={detail.substitute}
                    />
                    <span id={nameId} className="team-detail__name">{detail.name}</span>
                </span>
            );
        default:
            return detail[column.key];
    }
};

const SportsmenStateIcon = ({abandoned, participates, starting, substitute}) => {
    if (abandoned) {
        return <span className="team-detail__removed-icon glyphicon glyphicon-arrow-left"/>;
    }
    if(substitute && starting) {
        return <span className="team-detail__added-icon glyphicon glyphicon-arrow-right"/>;
    }
    if (!abandoned && participates) return null;
    if (!participates) {
        return <span className="team-detail__removed-icon glyphicon glyphicon-remove"/>;
    }
};

const PredictionImg = ({jersey, image, title}) => {
    if(jersey) {
        return <img className="prediction-row__icon" src={`/images/jersey-${jersey}.gif`} title={title}/>
    }
    if(image) {
        return <img className="prediction-row__icon" src={`/main/images/${image}`} title={title}/>
    }
    return <span>{title}</span>
};


export default TeamDetailsTableSimple;